import {dispatch} from '@wordpress/data';
import {useEffect} from '@wordpress/element';



/**
 * [shetradesBlockView description]
 * @param  {[type]} props [description]
 * @return {[type]}       [description]
 */
export function shetradesBlockView(props) {

	/**
	 * [_dispatchStoriesSubmit description]
	 * @param  {[type]} e [description]
	 * @return {[type]}   [description]
	 */
	function _dispatchStoriesSubmit(e) {
		jQuery('#form_stories').submit();
	} 

 
	return (				
      <input type="submit" id="form_stories_submit" name="form_stories_submit" value="Search" className="submit button-cta" onClick={(e) => _dispatchStoriesSubmit(e)} />
	);

}